class ListWithImageReveal {
  constructor(el) {
    this.el = el;
    this.images = this.el.querySelectorAll('.lwir__image');
    this.items = this.el.querySelectorAll('.lwir__item');
    this.watchItemHover();
  }

  watchItemHover() {
    this.items.forEach(item => {
      const index = parseInt(item.getAttribute('data-index'));
      item.addEventListener('mouseenter', () => {
        this.updateImageAtIndex(index);
      });
      item.addEventListener('mouseleave', () => {
        this.updateImageAtIndex(index);
      });
    });
  }

  updateImageAtIndex(index) {
    this.images.forEach((img) => {
      // if image is not displayed (mobile layout), skip
      if(img.offsetParent === null) return;

      if (img.getAttribute('data-index') == index) {
        img.classList.toggle('active');
      } 
    });
  }
}

export const InitListWithImageReveal = () => {
  const els = document.querySelectorAll('.lwir');
  els.forEach(el => {
    new ListWithImageReveal(el);
  });
}